import cookie from 'js-cookie'

const cookieStorage = {
    getItem(key) {
        return cookie.get(key)
    },

    setItem(key, val) {
        cookie.set(key, val)
    },

    removeItem(key) {
        cookie.remove(key)
    }
}

let storage = localStorage;

try {
    localStorage.setItem('test', 'test')
    localStorage.removeItem('test')
} catch (e) {
    storage = cookieStorage
}


export default storage



// WEBPACK FOOTER //
// ./src/Infrustructure/localStorageService.js